// extracted by mini-css-extract-plugin
module.exports = {"harvestList":"PcHarvest_harvestList_Dn6QW","card":"PcHarvest_card_1CeA4","title":"PcHarvest_title_1YidM","btn":"PcHarvest_btn_2Trmi"};